export var settings;
(function (settings) {
    settings.dVideo = {
        enabled: false,
        type: "facebook.video",
        params: {
            ref: '1578195445561131',
            url: "https://www.facebook.com/afcajax/videos/1578195445561131/"
        }
    };
    settings.blueBillyWig = {
        account_id: 'voetbalflitsen'
    };
    settings.globalPrefix = '__s_';
    settings.dPopupRefresh = false;
    settings.dAutoPlayVideos = false;
    settings.scrollOffsetContentUpdate = 40;
    settings.videoTypes = {
        youtube: "youtube.video",
        twitter: "twitter.video"
    };
    settings.linkDumpInfoMessage = 'Dit zijn linkdumps, door bezoekers ingestuurd. Redactie heeft dit niet zelf geplaatst.';
    settings.mediaQueries = {
        mob1: "screen and (max-width: 350px)",
        mob2: "screen and (max-width: 400px)",
        mob3: "screen and (max-width: 450px)",
        mob4: "screen and (max-width: 500px)",
        mob5: "screen and (max-width: 600px)",
        tab1: "screen and (max-width: 700px)",
        tab2: "screen and (max-width: 800px)",
        tab3: "screen and (max-width: 900px)",
        tab4: "screen and (max-width: 1000px)",
        tab5: "screen and (max-width: 1100px)",
        web1: "screen and (max-width: 1200px)",
        web2: "screen and (max-width: 1300px)",
        web3: "screen and (max-width: 1400px)",
        web4: "screen and (max-width: 1500px)",
        web5: "screen and (max-width: 1600px)",
        mqCollapseMenu: "screen and (max-width: 1000px)",
        mqShowPopup: "screen and (max-width: 1100px)"
    };
    const apiPath = '/api/v1/';
    settings.apiVideoPath = apiPath + 'video/';
    settings.slideOffsetNextPage = 0;
    settings.localStorageVersion = 1;
    settings.maxMediaHistory = 30;
    settings.useArticlePopupOnWeb = false;
})(settings || (settings = {}));
